import { useState, useEffect } from "react";
import { Spin } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

import Logo from "images/logo.png";

const Component = ({ footerText }) => {
	const initialState = {
		callNumber: {},
	};

	const [state, setState] = useState(initialState);
	const { loaded, callNumber } = state;
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	const componentDidMount = () => {
		API.contact()
			.then(({ data: { phoneNumbers } }) => {
				const callNumber = phoneNumbers.filter((i) => i.type === "mobile")[0];

				setState((prevState) => ({
					...prevState,
					callNumber,
					loaded: true,
				}));
			})
			.catch();
	};

	useEffect(componentDidMount, []);

	return (
		<div className="spa-footer">
			<div className="container">
				{loaded ? (
					<div className="wrap">
						<span
							className="arrow-up"
							onClick={scrollToTop}
						>
							<Icons.ArrowUp />
						</span>
						<div className="info">
							<Link
								to="/"
								className="logo"
							>
								<img
									src={Logo}
									alt="باکلید"
								/>
								{Resources.bakelid}
							</Link>
							<p className="desc">{footerText}</p>
							<div className="support-wrapper">
								<Link
									to={`tel:${callNumber?.number}`}
									target="_blank"
									rel="noopener noreferrer"
									className="support"
								>
									<span className="text">{Resources.supportText}</span>
									<span className="phone">{callNumber?.number}</span>
									<Icons.CallingBold className="icon" />
								</Link>
							</div>
						</div>
						<div className="pages">
							<span className="title">{Resources.services}</span>
							<ul className="list">
								<li>
									<Link to="/about">{Resources.aboutUs}</Link>
								</li>
								<li>
									<Link to="/support">{Resources.support}</Link>
								</li>
								<li>
									<Link to="/contact">{Resources.contactUs}</Link>
								</li>
								<li>
									<Link to="/faq">{Resources.faq}</Link>
								</li>
								<li>
									<Link to="/terms">{Resources.terms}</Link>
								</li>
							</ul>
						</div>
						<div className="links">
							<div className="google">
								<a
									href="/bakelid-app.apk"
									target="_blank"
									download
								>
									<span>{`${Resources.download} ${Resources.direct} ${Resources.application}`}</span>
								</a>
								<a
									href="https://play.google.com/store/apps/details?id=net.hoomaan.bakelid"
									target="_blank"
								>
									{`${Resources.receive} ${Resources.from}`}
								</a>
							</div>
							{/* <ul className="list">
              <li>
                <a href="#">
                  <img src={Enamad} alt="enamad" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={Union} alt="union" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={Neshan} alt="neshan" />
                </a>
              </li>
            </ul> */}
						</div>
					</div>
				) : (
					<Spin className="page-loading" />
				)}
			</div>
		</div>
	);
};

export default connect((state) => {
	return {
		footerText: state.settings.footerText,
	};
})(Component);
